/**
 * 一天的毫秒数
 */
export const ONEDAYTIME = 24 * 60 * 60 * 1000;

/**
 * 性别列表
 */
export const SexList = [
    {
        label: '男',
        value: '1',
    },
    {
        label: '女',
        value: '2',
    },
];

/**
 * 订单状态列表
 */
export const OrderStatus = ['待支付', '已取消', '已取消', '已完成', '退款成功', '退款失败', '退款中'];

/**
 * 高顿小课堂微信信息
 */
export const publicQrDate = {
    mobileNo: '15901888336',
    project: 'CMA',
    projectId: 1000057,
    staffId: 6370,
    weChatAccount: 'gaoduncpalm',
    weChatAvatar: 'https://gaodun-share.oss-cn-hangzhou.aliyuncs.com/uploadimgs/tmp/upload/202005/15/9022f_20200515105233.jpg',
    weChatName: '财会小课堂',
    weChatQrCode: 'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202006/08/13308_20200608100014.png',
};

/**
 * 字符串过滤emoji正则
 */
export const strPattern =
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\u00A9|\u00AE|\u3030/gi;

/**
 * 活动计划版本
 */
export const PLANVERSION = {
    NotLinkToIndex: 'JUMP_NO_INDEX',
};

/**
 * 活动方式
 */
export const ACTIVITYWAY = {
    //拼团
    groupon: 'ACTIVITY_GROUPON',
    //秒杀
    seckill: 'ACTIVITY_SECKILL',
    //表单
    survey: 'ACTIVITY_SURVEY',
    original: 'ACTIVITY_BUY_SEPARATELY',
};

/**
 * 真拼团类型
 */
export const GUIDEFLOW = {
    wechat_share: 'WECHAT_SHARE', //进入公众号获取分享海报
    direct_share: 'DIRECT_SHARE', // 直接进行分享
    direct_poster: 'DIRECT_POSTER', // 直接获取海报
    share_and_poster: 'SHARE_AND_POSTER', // 分享+海报
};

/**
 * 拼团状态列表
 */
export const GROUPSTATUS = {
    processing: 'PROCESSING',
    paying: 'PAYING',
    finished: 'FINISHED',
    failed: 'FAILED',
};

/**
 * 拼团状态
 */
export const ChexkGroupStatus = {
    PROCESSING: '拼团中',
    PAYING: '支付中',
    FINISHED: '拼团成功',
};

/**
 * 商品类型对应上课按钮内容
 */
export const ProductTypeBtnTexts = {
    0: '立即报名',
    1: '去学习',
    2: '去上课',
    3: '去查看',
    4: '去查看',
    5: '待开始',
    6: '登录',
    7: '已结束',
};

/**
 * 预约签到
 */
export const StencilTypeTexts = {
    1: '预约',
    2: '签到',
};

/**
 * 百家姓
 */
export const SURNAME =
    '赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨朱秦尤许何吕施张孔曹严华金魏陶姜戚谢邹喻柏水窦章云苏潘葛奚范彭郎鲁韦昌马苗凤花方俞任袁柳酆鲍史唐费廉岑薛雷贺倪汤滕殷罗毕郝邬安常乐于时傅皮卞齐康伍余元卜顾孟平黄和穆萧尹姚邵湛汪祁毛禹狄米贝明臧计伏成戴谈宋茅庞熊纪舒屈项祝董梁杜阮蓝闵席季麻强贾路娄危江童颜郭梅盛林刁钟徐邱骆高夏蔡田樊胡凌霍虞万支柯昝管卢莫经房裘缪干解应宗丁宣贲邓郁单杭洪包诸左石崔吉钮龚程嵇邢滑裴陆荣翁荀羊於惠甄曲家封芮羿储靳汲邴糜松井段富巫乌焦巴弓牧隗山谷车侯宓蓬全郗班仰秋仲伊宫宁仇栾暴甘钭厉戎祖武符刘景詹束龙叶幸司韶郜黎蓟薄印宿白怀蒲邰从鄂索咸籍赖卓蔺屠蒙池乔阴鬱胥能苍双闻莘党翟谭贡劳逄姬申扶堵冉宰郦雍卻璩桑桂濮牛寿通边扈燕冀郏浦尚农温别庄晏柴瞿阎充慕连茹习宦艾鱼容向古易慎戈廖庾终暨居衡步都耿满弘匡国文寇广禄阙东欧殳沃利蔚越夔隆师巩厍聂晁勾敖融冷訾辛阚那简饶空曾毋沙乜养鞠须丰巢关蒯相查后荆红游竺权逯盖益桓公万俟司马上官欧阳夏侯诸葛闻人东方赫连皇甫尉迟公羊澹台公冶宗政濮阳淳于单于太叔申屠公孙仲孙轩辕令狐钟离宇文长孙慕容鲜于闾丘司徒司空丌官司寇仉督子车颛孙端木巫马公西漆雕乐正壤驷公良拓跋夹谷宰父谷梁晋楚闫法汝鄢涂钦段干百里东郭南门呼延归海羊舌微生岳帅缑亢况郈有琴梁丘左丘东门西门商牟佘佴伯赏南宫墨哈谯笪年爱阳佟第五言福';

/**
 * 默认挽留层图片
 */
export const defaultLayerUrl = 'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202011/30/f6ac2_20201130172251.png';

export const FORM_CODES = {
    // 申请入驻表单
    ApplicationForSettlement: 'FM_pFAtKj',

    // 院校测评表单
    CollegeEvaluation: 'FM_YkPQzM',

    // 购买专业课咨询产品
    ProfessionalCourseConsultation: 'FM_UoWjcH',

    // 购买择校专业规划咨询
    SchoolChoiceConsultation: 'FM_BmNqWJ',
};

export const ACTIVITY_PAGE_URL = {
    H5: {
        ACTIVITY_SECKILL: `/activitydetail`, // 秒杀
        ACTIVITY_GROUPON: `/groupbuy`, // 拼团
        ACTIVITY_SURVEY: `/questionnaire`, // 表单
        ACTIVITY_APPOINTMENT_SIGN: `/appointsign`, // 预约签到
        ACTIVITY_LOTTERY: {
            0: `/lotterydraw`, // 大屏
            1: `/lotterypage`, // 手机
        }, // 抽奖
        ACTIVITY_GET_MATERIALS: `/getmaterial`, // 资料领取
        ACTIVITY_READ_ARTICLE: `/readarticles`, // 阅读文章
    },
    MINNIAPP: {
        ACTIVITY_SECKILL: `/pages/spike/index`, // 秒杀
        ACTIVITY_GROUPON: `/pages/groupon/index`, // 拼团
        ACTIVITY_SURVEY: `/pages/questionnaire/index`, // 表单
        ACTIVITY_APPOINTMENT_SIGN: `/pages/appointsign/index`, // 预约签到
        ACTIVITY_LOTTERY: {
            0: '/pages/lotterydraw/index', // 大屏
            1: `/pages/lotterypage/index`, // 手机
        }, // 抽奖
        ACTIVITY_GET_MATERIALS: `/pages/getmaterials/index`, // 资料领取
        ACTIVITY_LIVING: `/pages/livecoursedetails/index`, // 直播课
        ACTIVITY_READ_ARTICLE: `/pages/readarticles/index`, // 阅读文章
    },
};

// 屏蔽支付宝支付
export const ShieldingAlipayProjects = [
    100535968 /* 量化CTA */, 100535969 /* 职业兴趣 */, 1000632 /* CPA */, 1000645 /* 中级职称 */, 100520929 /* 公务员 */, 1000054 /* CFA */,
    100520945 /* 在职研 */, 100534842 /* 军队文职 */, 100523443 /* 事业单位 */, 2012842 /* 考研 */,
];
export const ShieldingAlipayChannelId = [4567 /* 今日头条 */, 4563 /* 抖音广告 */];
